import * as React from 'react';
import { Link } from 'react-router';
import styled from 'styled-components';
import { rem, border } from 'polished';
import {
  FlexCol,
  FlexRowCenterVertical,
  FlexRow,
} from '../../Defaults/Flexbox/Flexbox';
import { __ } from 'react-i18n';
import { TextP } from '../../Defaults/Text';
import { InfoText, InfoType } from '../General/InfoText';
import { CheckBox } from '../General/Checkbox';
import { Input } from '../General/Input';
import { FormInput } from '../Form/FormInput';
import { AddressBlock } from './AddressBlock';
import { NewAddressBlock } from './NewAddressBlock';

interface Props {
  addresses: any[];
  onAddressClick: (id) => void;
  currentId: number | null;
}

function AddressesDeliveryList({
  addresses,
  onAddressClick,
  currentId,
}: Props) {
  return (
    <Wrapper>
      {addresses &&
        addresses.map(address => (
          <AddressBlock
            onClick={onAddressClick}
            key={address.id}
            address={address}
            active={currentId === address.id}
          />
        ))}
      {/* <NewAddressBlock active={currentId === null} onClick={onAddressClick} /> */}
    </Wrapper>
  );
}

const Wrapper = styled(FlexRow)`
  flex-flow: row wrap;
  margin-bottom: ${rem(24)};

  ${({ theme }) => theme.mediab.m580`
    margin-bottom: 0;
  `}
`;

export { AddressesDeliveryList };
